import { render, staticRenderFns } from "./ListGuidancePage.vue?vue&type=template&id=bf730140&scoped=true&"
import script from "./ListGuidancePage.vue?vue&type=script&lang=js&"
export * from "./ListGuidancePage.vue?vue&type=script&lang=js&"
import style0 from "./ListGuidancePage.vue?vue&type=style&index=0&id=bf730140&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf730140",
  null
  
)

export default component.exports